'use strict';

import { duration as durationUtil } from '@utils/date/duration';

angular.module('eva2-angular').filter('duration', function() {
  return function(duration, isVerbose, customGetText) {
    return durationUtil(duration, isVerbose, customGetText);
  };
});
